module.exports = __webpack_public_path__ + "static/media/dise13.53c5a25a.jpg";